module.exports = __webpack_public_path__ + "static/media/drugs.a5cc3636.svg";